export const trimText = <T>(text: T): T => {
  if (typeof text !== "string") return text;

  return (text as string)
    .split("\n")
    .filter((x) => x.length > 0)
    .join("\n") as T;
};
